import React from 'react';
import Footer from './footer';
import Header from './header';
import ReactGA from 'react-ga4';

ReactGA.send(window.location.pathname);

const capabilities = [
    {
        label: 'Mobile Apps',
        desc: 'Native iOS and Android apps built for real people.',
    },
    {
        label: 'Web',
        desc: 'Fast, focused web products that do exactly what they need to.',
    },
    {
        label: 'AI',
        desc: 'AI built into our apps where it genuinely makes a difference.',
    },
    {
        label: 'Design',
        desc: 'Interfaces that get out of the way and let the product speak.',
    },
];

const products = [
    {
        name: 'Peticle',
        tag: 'iOS App',
        desc: 'AI-powered pet health analysis and tracker.',
        href: 'https://peticle.app',
        cta: 'peticle.app',
    },
    {
        name: 'Bundu',
        tag: 'Mobile App',
        desc: 'Connects you to outdoor experiences near you.',
        href: 'https://bundu.club/',
        cta: 'bundu.club',
    },
];

function Home() {
    return (
        <div className="bg-[#080808] min-h-screen text-white">
            <Header />

            {/* Hero */}
            <section className="px-6 mx-auto max-w-7xl pt-40 pb-32 border-b border-white/5">
                <div className="max-w-3xl">
                    <p className="text-green-400 text-xs uppercase tracking-widest mb-6 font-medium">
                        Software Studio · Joburg, South Africa
                    </p>
                    <h1 className="text-5xl sm:text-7xl font-bold tracking-tight leading-none mb-8">
                        We build<br />
                        <span className="text-[#444]">things that work.</span>
                    </h1>
                    <p className="text-[#888] text-lg sm:text-xl leading-relaxed max-w-xl">
                        Apps, websites, and AI — built by one person who cares about craft.
                    </p>
                </div>
            </section>

            {/* Capabilities */}
            <section className="px-6 mx-auto max-w-7xl py-24 border-b border-white/5">
                <p className="text-xs uppercase tracking-widest text-[#555] mb-12 font-medium">
                    What we build
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5">
                    {capabilities.map((cap) => (
                        <div key={cap.label} className="bg-[#080808] p-8 hover:bg-[#0f0f0f] transition-colors duration-200">
                            <h3 className="text-white font-semibold mb-3">{cap.label}</h3>
                            <p className="text-[#666] text-sm leading-relaxed">{cap.desc}</p>
                        </div>
                    ))}
                </div>
            </section>

            {/* Products */}
            <section className="px-6 mx-auto max-w-7xl py-24 border-b border-white/5">
                <p className="text-xs uppercase tracking-widest text-[#555] mb-12 font-medium">
                    Our products
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    {products.map((product) => (
                        <div
                            key={product.name}
                            className="border border-white/5 rounded-xl p-8 hover:border-white/10 transition-colors duration-200 flex flex-col"
                        >
                            <div className="flex items-center justify-between mb-6">
                                <span className="text-white font-semibold text-lg">{product.name}</span>
                                <span className="text-[#555] text-xs uppercase tracking-wider border border-white/10 px-2.5 py-1 rounded-full">
                                    {product.tag}
                                </span>
                            </div>
                            <p className="text-[#666] text-sm leading-relaxed flex-1">{product.desc}</p>
                            {product.href ? (
                                <a
                                    href={product.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-6 text-green-400 text-sm font-medium hover:text-green-300 transition-colors no-underline inline-flex items-center gap-1.5"
                                >
                                    {product.cta}
                                    <span className="text-xs">↗</span>
                                </a>
                            ) : (
                                <span className="mt-6 text-[#555] text-sm">{product.cta}</span>
                            )}
                        </div>
                    ))}
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Home;
